import styles from "./CartAmountSecondary.module.css"
import { Plus, Minus } from 'lucide-react';
/**
* Props for the CartAmountSecondary component.
*/ 
interface CartAmountSecondaryProps{
    amountInCart?:number, // Current amount
    onIncrease?: ()=>void, // Increase the amount
    onDecrease?:()=>void, // Decrease the amount
    className?:string, // Optional additional class
    colorVariant?: string, // Color variant
    disabled?: boolean // Disable the button
    disabledDecrease?: boolean // Disable the decrese button
    disabledIncrease?: boolean // Disable the increase button
}

/**
* A button for incrementing and decrementing some value.
*
* @param props CartAmountSecondary props
* @param {number} props.amountInCart - Current amount
* @param {string} props.colorVariant - Color variant
* @param {boolean} props.disabled - Disable the button
* @param {boolean} props.disabledDecrease - Disable the decrease button
* @param {boolean} props.disabledIncrease - Disable the increase button
* @param {string} props.className - Optional additional class
* @param {() => void} props.onIncrease - Increase the amount
* @param {() => void} props.onDecrease - Decrease the amount
* @returns TSX.Element
*/
const CartAmountSecondary = ({amountInCart, onIncrease, onDecrease, className, colorVariant , disabled, disabledDecrease, disabledIncrease} : CartAmountSecondaryProps) => {
    
    return (
        <>
            <div className={className ? `${styles.CartAmountSecondary} ${className}` : `${styles.CartAmountSecondary}`}>
                <button 
                className={`${styles.CartAmountDecrease}  ${colorVariant == "secondary" ? styles.Secondary : ""} ${colorVariant == "primary" ? styles.Primary : ""} ${colorVariant == "neutral" ? styles.Neutral : ""} ${disabled || disabledDecrease ? styles.Disabled : ''}`}
                onClick={onDecrease}
                disabled={disabled || disabledDecrease} 
                >
                    <Minus/>
                </button>
                <div className={styles.CartAmountText}>
                    <p>{amountInCart}</p>
                </div>
                <button 
                className={`${styles.CartAmountIncrease}  ${colorVariant == "secondary" ? styles.Secondary : ""} ${colorVariant == "primary" ? styles.Primary : ""} ${colorVariant == "neutral" ? styles.Neutral : ""} ${disabled || disabledIncrease ? styles.Disabled : ''}`}
                onClick={onIncrease}
                disabled={disabled || disabledIncrease}
                >
                    <Plus/>
                </button>
            </div>
        </>
    )
}
export default CartAmountSecondary